const groupByCrop = data => {
  const cropMap = {};
  const farmMaps = {};
  const fieldMaps = {};
  data.forEach(farm => {
    farm.fields.forEach(field => {
      field.cropzones.forEach(cropzone => {
        const cropId = cropzone.crop.id;
        if (!cropMap[cropId]) {
          cropMap[cropId] = { name: cropzone.crop.name, farms: [] };
          farmMaps[cropId] = new Map();
          fieldMaps[cropId] = new Map();
        }
        let existingFarm = farmMaps[cropId].get(farm.id);
        if (!existingFarm) {
          existingFarm = { ...farm, fields: [] };
          cropMap[cropId].farms.push(existingFarm);
          farmMaps[cropId].set(farm.id, existingFarm);
        }
        const fieldKey = `${farm.id}:${field.id}`;
        let existingField = fieldMaps[cropId].get(fieldKey);
        if (!existingField) {
          existingField = { ...field, cropzones: [] };
          existingFarm.fields.push(existingField);
          fieldMaps[cropId].set(fieldKey, existingField);
        }
        existingField.cropzones.push(cropzone);
      });
    });
  });
  return Object.entries(cropMap)
    .map(([id, crop]) => ({ id, ...crop }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export default groupByCrop;
